import React from "react";
import { motion } from "framer-motion";

// Lightweight scroll/entrance reveal wrapper.
export function Reveal({ children, delay = 0, y = 24, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, color = "signal", className = "" }) {
  const c = color === "gold" ? "text-gold" : color === "health" ? "text-health" : "text-signal";
  return <p className={`overline ${c} ${className}`}>{children}</p>;
}

export default Reveal;
